import { render, staticRenderFns } from "./AuctionVideos.vue?vue&type=template&id=57efa4b6&scoped=true"
import script from "./AuctionVideos.vue?vue&type=script&lang=js"
export * from "./AuctionVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57efa4b6",
  null
  
)

export default component.exports